import { Link } from 'react-router-dom';
import DisplayToggles from './DisplayToggles';

export function Logo() {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
      <div style={{
        width: 32, height: 32, borderRadius: 7,
        background: 'linear-gradient(135deg,#16a34a,#2563eb)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <span style={{ color: '#fff', fontWeight: 800, fontSize: 14 }}>IP</span>
      </div>
      <h1 style={{ fontSize: 22, fontWeight: 700, letterSpacing: '-0.4px' }}>
        INPULSE <span style={{ color: 'var(--green)' }}>Core Operations</span>
      </h1>
    </div>
  );
}

export function UserChip({ session, onSignOut }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
    <DisplayToggles />
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '6px 12px', background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 8, fontSize: 13 }}>
      <div style={{ width: 24, height: 24, borderRadius: '50%', background: 'linear-gradient(135deg,#16a34a,#2563eb)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <span style={{ color: '#fff', fontSize: 10, fontWeight: 700 }}>{session.user.email[0].toUpperCase()}</span>
      </div>
      <span style={{ color: 'var(--text2)', maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{session.user.email}</span>
      <button onClick={onSignOut} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text3)', fontSize: 12, marginLeft: 4 }}>Sign out</button>
    </div>
    </div>
  );
}

export function MenuLink() {
  return (
    <Link to="/" style={{ fontSize: 13, fontWeight: 600, color: 'var(--text2)', padding: '6px 10px', border: '1px solid var(--border)', borderRadius: 8, background: 'var(--card)' }}>
      ← Menu
    </Link>
  );
}
